module.exports = __webpack_public_path__ + "img/02-Customer-Process.25eda6c4.svg";